$(document).ready(function () {
    'use strict';

    if ($('.js_carzClubSignupForm').length) {
        console.log('carz club signup form exists')
        submitForm('.js_carzClubSignupForm');
    }
});